// extracted by mini-css-extract-plugin
export default {"r_l":"f81214f4c8 b1d8eb32c5","t":"_8e307196b5"};